module.exports = __webpack_public_path__ + "static/zenq-8b10868b7d0d3bf170f639299016c9f6.jpg";